import { useTranslation } from 'react-i18next';
import { ShieldCheck } from 'lucide-react';
import { useBooking } from '@features/booking/state';

/**
 * Persistent banner shown on all booking steps when the user is in
 * the early-access (request) flow. Matches the legacy pre-access-alert
 * component that appears on menu selection, time slots, personalization,
 * and confirmation steps.
 */
export function EarlyAccessBanner() {
  const { t } = useTranslation('booking');
  const { isEarlyAccessFlow } = useBooking();

  if (!isEarlyAccessFlow) return null;

  return (
    <div className="w-full px-6 mb-4">
      <div className="flex items-center gap-3 bg-amber-50 border border-amber-200 rounded-xl px-4 py-3">
        <ShieldCheck className="w-5 h-5 text-amber-600 flex-shrink-0" />
        <div>
          <p className="text-sm font-semibold text-amber-900">
            {t('EARLY_ACCESS_BANNER_TITLE')}
          </p>
          <p className="text-xs text-amber-800">
            {t('EARLY_ACCESS_IS_NOT_A_RESERVATION')}
          </p>
        </div>
      </div>
    </div>
  );
}
